import { LicensedPartners as LicensedPartnersContent } from 'LicensedPartners';

const LicensedPartersBySportTab = () => {
  return <LicensedPartnersContent />;
};

export default LicensedPartersBySportTab;
